module.exports = "/images/discover-3.png";